import { render, staticRenderFns } from "./kargoTesellumYazdir.vue?vue&type=template&id=511dc2c5"
import script from "./kargoTesellumYazdir.vue?vue&type=script&lang=js"
export * from "./kargoTesellumYazdir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports